// extracted by mini-css-extract-plugin
export default {"root":"ZpvfOSRC","title":"f0csvcsT","range":"mwJ9CG3Q"};